<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZysfRW/images/cover.jpg?1703000751174" alt="This image is the cover for the book Ligonier Valley Vignettes, American Chronicles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ligonier Valley Vignettes, American Chronicles
      </h1>
      <p class="bookDescription body article font2">
        <p>Secluded between Laurel Mountain and Chestnut Ridge, the Ligonier Valley has been the mountain playground of western Pennsylvania since the nineteenth century. Yet this picturesque retreat was at the tumultuous center of history--during the French and Indian War, Fort Ligonier was key to the British strategy, and in the late nineteenth century, the Ligonier Valley Rail Road helped transform the industry of the region. Author Jennifer Sopko traces the story of the valley and its residents through a series of fascinating vignettes. From the earliest histories to nostalgic reminiscences of the Ligonier Opera House, socials at the Valley Dairy ice cream parlor and bygone days at Idlewild Park, Sopko captures the history and spirit of the Ligonier Valley and its communities.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jennifer Sopko, Shirley G. McQuillis Iscrupe
      </h2>
      
      <p class="authorDescription body article">Jennifer Sopko is a freelance writer, and joined the Latrobe Bulletin in 2003.  She is a contributor to the Westmoreland History Magazine, a publication of the Westmoreland County Historical Society, as well as the Ligonier Echo and the Tube City Almanac. She is a volunteer at the Ligonier Valley Library's Pennsylvania Room. Shirley McQuillis Iscrupe is the 2012 recipient of the Arthur St. Clair Historic Preservation Award for Preservation of the history of Ligonier Valley. She is currently the Pennsylvania Room Archivist for the Ligonier Valley Library.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?12d6b304